var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C4.065 1 2.5 2.565 2.5 4.5C2.5 7.125 6 11 6 11C6 11 9.5 7.125 9.5 4.5C9.5 2.565 7.935 1 6 1ZM3.5 4.5C3.5 3.12 4.62 2 6 2C7.38 2 8.5 3.12 8.5 4.5C8.5 5.94 7.06 8.095 6 9.44C4.96 8.105 3.5 5.925 3.5 4.5ZM4.75 4.5C4.75 3.80964 5.30964 3.25 6 3.25C6.44658 3.25 6.85924 3.48825 7.08253 3.875C7.30582 4.26175 7.30582 4.73825 7.08253 5.125C6.85924 5.51175 6.44658 5.75 6 5.75C5.30964 5.75 4.75 5.19036 4.75 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsPlace);
export default __webpack_public_path__ + "static/media/gps-place.de99cb08cf4db69fcbfdf315937f9b55.svg";
export { ForwardRef as ReactComponent };